import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SearchService } from '@modules/search/services/search.service';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { ScrollerModule } from 'primeng/scroller';
import { CommonModule } from '@angular/common';
import { DateAgoPipe } from '@shared/pipes/date-ago.pipe';
import { SvgIconComponent } from '@ngneat/svg-icon';
@Component({
  selector: 'app-search-chat-history',
  standalone: true,
  imports : [
    ButtonModule,
    TooltipModule,
    ScrollerModule,
    CommonModule,
    DateAgoPipe,
    SvgIconComponent
  ],
  templateUrl: './search-chat-history.component.html',
  styleUrl: './search-chat-history.component.scss',
})
export class SearchChatHistoryComponent implements AfterViewInit{
  chatHistoryGrouped : ChatHistoryGrouped[] = [] as ChatHistoryGrouped[];
  @Input() getHistory : any;
  @Input() getHistoryByID : any;
  @Input() maxHeight : string = '100%';
  @Input() doc : any;
  @Output() chatHistoryUpdate = new EventEmitter<ChatHistory>();
  @ViewChild('searchChatHistory') searchChatHistory!: ElementRef;
  Object = Object;
  constructor(
    private _search : SearchService
  ) {}


  query: any = {
    limit : 20,
  }
  isLoading : boolean = false;
  totalDocs : number = 0;
  ngOnInit() {
    this.getChatHistory();
  }

  ngAfterViewInit() {
    this.searchChatHistory.nativeElement.addEventListener('scroll', this.onScroll.bind(this));
  }

  getChatHistory() {
    let params :any = {...this.query};
    this.isLoading = true;
    let body : any = {};
    if(this.doc){
      body.esId = this.doc._id;
      body.esIndex = this.doc._index;
    }
    this.getHistory(params,body).subscribe({
      next: (response:any) => {
        this.isLoading = false;
        this.chatHistoryGrouped =  response.docs;
        this.totalDocs = response.totalDocs;
      },
      error: (error:any) => {
        this.isLoading = false;
        console.log(error);
      }
    });
  }

  loadMoreChatHistory() {
    if (this.query.limit < this.totalDocs) {
      this.query.limit += 20;
      this.getChatHistory();
    }
  }

  onScroll(event: any) {
    const element = event.target;
    const scrollTop = element.scrollTop;
    const scrollHeight = element.scrollHeight;
    const clientHeight = element.clientHeight;

    if (scrollTop + clientHeight >= scrollHeight * 0.9 && !this.isLoading) {
      this.loadMoreChatHistory();
    }
  }
  emptyChat :any = {
    "_id": "",
    "chatId": "",
    "heading": "",
    "messages": [
      {
      role: 'user',
      content: '',
      },
      {
      role: 'assistant',
      content: '',
    }],
    "createdAt": "",
    "updatedAt": ""
  }
  emptyResponse :any = {
    "_id": "",
    "chatId": "",
    "heading": "",
    "messages": [
      {
      role: 'assistant',
      content: 'Sorry, I could not process your request. Please try again later.',
    }],
    "createdAt": "",
    "updatedAt": ""
  }

  getChatHistoryAndAppend(chat : ChatHistory) {
    chat.loading = true;
    let params = {
      id : chat._id
    };
    this.chatHistoryUpdate.emit(this.emptyChat);
    this.getHistoryByID(params).subscribe({
      next: (response:any) => {
        chat.loading = false;
        this.chatHistoryUpdate.emit(response);
      },
      error: (error:any) => {
        chat.loading = false;
        this.chatHistoryUpdate.emit(this.emptyResponse);
        console.log(error);
      }
    });
  }

}
export interface ChatHistory{
  "_id": string,
  "chatId": string,
  "heading": string,
  "createdAt": string,
  "updatedAt": string,
  "loading": boolean,
}
export interface ChatHistoryGrouped{
  date : string;
  histories: ChatHistory[];
}
